export default "__VITE_ASSET__8d514ed3__"